import {  FETCH_WORKOUTS, FETCH_WORKOUT_INFO, RESET_WORKOUTS, RESET_WORKOUT_INFO, UPDATE_ORDER_WORKOUTS } from '../actionTypes';

const initialState = {
  data: {},
  isLoadMore: false,
  info: {}
};

export default function(state = initialState, action = null){
  switch (action.type) {
    case FETCH_WORKOUTS:
      let isLoadMore = true;
      if (Object.keys(action.payload).length < 10) {
        isLoadMore = false;
      }
      return {
        ...state,
        data: {...state.data, ...action.payload},
        isLoadMore: isLoadMore
    }
    case UPDATE_ORDER_WORKOUTS:
      const items = action.payload;
      let obj = {};
      for(let i = 0; i < items.length; i++) {
         const d = items[i];
         obj[d._id] = d;
      }
      return {
        ...state,
        data: obj
    }
    case FETCH_WORKOUT_INFO:
      return {
        ...state,
        info: action.payload
      }
    case RESET_WORKOUT_INFO:
      return {
        ...state,
        info: {}
      }
    case RESET_WORKOUTS:
      return initialState
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/workouts.js